export const compareObjectsOnFields = (obj1, obj2, field1, field2) => {
  return obj1[field1] === obj2[field1] && obj1[field2] === obj2[field2];
};
